import {
  Edit,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const BlacklistDeviceEdit = () => (
  <Edit actions={<EditActions />} mutationMode="pessimistic">
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput source="deviceId" validate={required()} />
      <TextInput source="createdAt" disabled />
      <TextInput source="updatedAt" disabled />
    </SimpleForm>
  </Edit>
);
